import {HarriMainRoutes} from "../hmodules/harri-main/harri-main.routes.js";
import {ReportingManagementRoutes} from "../hmodules/reporting-management/reporting-management.route.js";
import {ReportsManagementRoutes} from "../hmodules/reports-management/reports-management.routes.js";
import {JobCreateRoutes} from "../modules/job_create/job-create.routes.js";
import {DocsRoutes} from "../modules/docs/docs.routes.js";
import {ScheduleRoutes} from "../modules/team_schedule/employer/schedule/schedule.routes.js";
import {CandidateSignRoutes} from "../hmodules/on-boarding/candidate-sign/candidate-sign.routes.js";
import {EmployerReviewRoutes} from "../hmodules/on-boarding/employer-review/employer-review.routes.js";
import {AMSRoutes} from "../modules/ams/ams.routes.js";
import {HMAPRoutes} from "../modules/hmap/hmap.routes.js";
import {AMSCustomColumnsSettingsRoutes} from "../hmodules/ams-columns-settings/ams-columns-settings.routes.js";
import {RecruitmentHubRoutes} from "../hmodules/recruitment-hub/recruitment-hub.routes.js";
import {SettingsRoutes} from "../modules/settings/settings.routes.js";
import {TLEmployerSettingsRoutes} from "../modules/team_schedule/employer/settings/tl-employer-settings.routes.js";
import {InterviewManifestRoutes} from "../hmodules/interview-scheduling/interview-scheduling.routes.js";
import {DashboardsRoutes} from "../modules/dashboard/dashboards.routes.js";
import {AdamJSRoutes} from "../hmodules/adam/adam.routes.js";
import {JobTemplatesRoutes} from "../hmodules/job-templates/job-templates.routes.js";
import {PunchManagementRoutes} from "../hmodules/punch-management/punch-management.routes.js";
import {EmployeeCardRoutes} from "../modules/team_schedule/employer/employee-card/employee-card.routes.js";
import {HyperHireRoutes} from "../hmodules/hyper-hire/hyperhire.routes.js";
import {InterviewVideoRoutes} from "../hmodules/interview-video/interview-video.routes.js";
import {InterviewBankRoutes} from "../hmodules/interview-bank/interview-bank.routes.js"
import {VideoInterviewRoutes} from "../hmodules/interview-bank/video-interview.routes.js"
import {ScheduleBudgetingRoutes} from "../hmodules/team-live/schedule-budgeting/schedule-budgeting.routes.js";
import {TalentPoolRoutes} from "../hmodules/talent-pool/talent-pool.route.js";
import {JobApprovalRoutes} from "../hmodules/job-approval/job-approval.routes.js";
import {PunchPhotosExceptionsReportRoutes} from "../hmodules/team-live/reports/punch-photo-exceptions-report/punch-photo-exceptions-report.routes.js";
import {TeamLiveRequestsManagementEmployerRoutes} from "../hmodules/team-live-requests-management/team-live-requests-management-employer.routes.js";
import {TeamLiveEmployerRoutes} from "../hmodules/team-live/team-live-employer.routes.js";
import {QsrLoginRoutes} from "../hmodules/qsr-login/qsr-login.routes.js";
import {TLTeamEmployerRoutes} from "../modules/team_schedule/employer/team/tl-team-employer.route.js";
import {MaintenanceRoutes} from "../hmodules/maintenance/maintenance.routes.js";
import {carriRoutes} from "../hmodules/carri/carri.routes.js";
import {WotcRoutes} from "../hmodules/wotc/wotc.routes.js";
import {AtrsRoutes} from "../hmodules/authority-to-recruit/authority-to-recruit.routes.js";
import {TLReportsRoutes} from "../modules/team_schedule/employer/reports/tl-reports.routes.js";
import {PayRunsRoutes} from "../hmodules/pay-runs/pay-runs.routes.js";
import {HealthCheckRoutes} from "../hmodules/health-check/health-check.routes.js";
import {EEORoutes} from "../hmodules/eeo/eeo.routes.js"
import {AutoWageMatrixRoutes} from "../hmodules/auto-wage-matrix/auto-wage-matrix.routes.js";
import {TLClockTimeRoutes} from "../modules/team_schedule/employer/clock_time/tl-clock-time.routes.js";
import {TeamLiveReportsRoutes} from "../hmodules/team-live/reports/team-live_reports.routes.js";
import {CustomizedDashboardsRoutes} from "../hmodules/customized-dashboards/customized-dashboards.routes.js";
import {UserForgotPasswordRoutes} from "../hmodules/user-forgot-password/user-forgot-password.routes.js";
import {AccountSuspensionRoutes} from "../hmodules/account-suspension/account-suspension.routes.js";
import {OfferTemplatesRoutes} from "../hmodules/offer-templates/offer-templates.routes.js";
import {PerformanceRoutes} from "../modules/team_schedule/employer/performance/performance.routes.js";
import {ChatBotRoutes} from "../hmodules/chat-bot/chat-bot.routes.js";
import {ActivityBasedSchedulingRoutes} from "../hmodules/activity-based-scheduling/activity-based-scheduling.routes.js";
import {DemandForecastingRoutes} from "../hmodules/team-live/demand-forecasting/demand-forecasting.routes.js";
import {WendysLaborRoutes} from "../hmodules/team-live/wendys-labor/wendys-labor.routes.js";
import {BarriRoutes} from "../hmodules/barri/barri.routes.js";
import {CrmRoutes} from "../hmodules/crm/crm.routes.js";
import {OnboardingManagersNotificationsRoutes} from "../hmodules/onboarding-managers-notifications/onboarding-managers-notifications.routes.js";
import {ScreeningQuestionsRoutes} from "../hmodules/screening-questions/screening-questions.route.js";
import {LiveWireV2Routes} from "../modules/team_schedule/employer/live-wire-v2/live-wire-v2.routes.js";
import {PeoplePlatformRoutes} from "../hmodules/people-platform/people-platform.routes.js";
import {HrActionsTemplatesRoutes} from "../hmodules/hr-actions-templates/hr-actions-templates.routes.js";

import {TeamliveRequestsEmployerRoutes} from "../hmodules/team-live-requests/teamlive-requests-employer.routes.js";
import {HarriEngageRoutes} from "../hmodules/harri-engage/harri-engage.routes.js";
import {McDLaborRoutes} from "../hmodules/team-live/mcd-labor/mcd-labor.routes.js";
import {JibLaborRoutes} from "../hmodules/jib-labor/jib-labor.routes.js";
import {GastronomyLaborRoutes} from "../hmodules/team-live/gastronomy-labor/gastronomy-labor.routes.js";
import {CarrolLaborRoutes} from "../hmodules/team-live/carrol-labor/carrol-labor.routes.js";
import {SourceHireLayoutRoutes} from "../hmodules/source-hire-layout/source-hire-layout.routes.js";
import {AvailabilityRequestsEmployerRoutes} from "../hmodules/team-live/availability-requests/availability-requests-employer.routes.js";
import {LiveScheduleAccessRoutes} from "../hmodules/live-schedule-access/live-schedule-access.routes.js";
import {PermissionManagementRoutes} from "../hmodules/permission-management/permission-management.routes.js";
import {TeamliveSettingsAuditRoutes} from "../hmodules/teamlive-settings-audit/teamlive-settings-audit.routes.js";
import {EngagementDashboardsRoutes} from "../hmodules/dashboards/dashboards.routes.js";
import {MinorSettingsManagementRoutes} from "../hmodules/minor-settings-management/minor-settings-management.routes.js";
import "../hui/hui.module.js";
import {TipsDistributionRoutes} from '../hmodules/tips-distribution/tips-distribution.routes.js';
import {TipsDistributionBulkRoutesJS} from "../hmodules/tips-distribution/tips-distribution-bulk.routes.js";
import {MiscellaneousPaymentRoutes} from "../hmodules/miscellaneous-payment/miscellaneous-payment.routes.js";
import {PerformanceSecondApprovalRoutes} from "../hmodules/performance-second-approval/performance-second-approval.routes.js";
import {ShiftTradeEmployerRoutes} from "../hmodules/shift-trade/shift-trade-employer.routes.js";

angular.merge(publicConfiguration['routes'], HarriMainRoutes);
angular.merge(publicConfiguration['routes'], AccountSuspensionRoutes);
angular.merge(publicConfiguration['routes'], UserForgotPasswordRoutes);
angular.merge(publicConfiguration['routes'], ReportsManagementRoutes);
angular.merge(publicConfiguration['routes'], ReportingManagementRoutes);
angular.merge(publicConfiguration['routes'], JobCreateRoutes);
angular.merge(publicConfiguration['routes'], SourceHireLayoutRoutes);
angular.merge(publicConfiguration['routes'], DocsRoutes);
angular.merge(publicConfiguration['routes'], CrmRoutes);
angular.merge(publicConfiguration['routes'], LiveWireV2Routes);
angular.merge(publicConfiguration['routes'], MaintenanceRoutes);
angular.merge(publicConfiguration['routes'], ScheduleRoutes);
angular.merge(publicConfiguration['routes'], CandidateSignRoutes);
angular.merge(publicConfiguration['routes'], EmployerReviewRoutes);
angular.merge(publicConfiguration['routes'], AMSRoutes);
angular.merge(publicConfiguration['routes'], JobTemplatesRoutes);
angular.merge(publicConfiguration['routes'], HMAPRoutes);
angular.merge(publicConfiguration['routes'], AMSCustomColumnsSettingsRoutes);
angular.merge(publicConfiguration['routes'], RecruitmentHubRoutes);
angular.merge(publicConfiguration['routes'], SettingsRoutes);
angular.merge(publicConfiguration['routes'], TLEmployerSettingsRoutes);
angular.merge(publicConfiguration['routes'], InterviewManifestRoutes);
angular.merge(publicConfiguration['routes'], DashboardsRoutes);
angular.merge(publicConfiguration['routes'], EmployeeCardRoutes);
angular.merge(publicConfiguration['routes'], ScheduleBudgetingRoutes);
angular.merge(publicConfiguration['routes'], HyperHireRoutes);
angular.merge(publicConfiguration['routes'], InterviewVideoRoutes);
angular.merge(publicConfiguration['routes'], TalentPoolRoutes);
angular.merge(publicConfiguration['routes'], InterviewBankRoutes);
angular.merge(publicConfiguration['routes'], VideoInterviewRoutes);
angular.merge(publicConfiguration['routes'], PunchPhotosExceptionsReportRoutes);
angular.merge(publicConfiguration['routes'], JobApprovalRoutes);
angular.merge(publicConfiguration['routes'], TeamLiveRequestsManagementEmployerRoutes);
angular.merge(publicConfiguration['routes'], TeamLiveEmployerRoutes);
angular.merge(publicConfiguration['routes'], AdamJSRoutes);
angular.merge(publicConfiguration['routes'], PunchManagementRoutes);
angular.merge(publicConfiguration['routes'], QsrLoginRoutes);
angular.merge(publicConfiguration['routes'], TLTeamEmployerRoutes);
angular.merge(publicConfiguration['routes'], carriRoutes);
angular.merge(publicConfiguration['routes'], WotcRoutes);
angular.merge(publicConfiguration['routes'], AtrsRoutes);
angular.merge(publicConfiguration['routes'], TLReportsRoutes);
angular.merge(publicConfiguration['routes'], PayRunsRoutes);
angular.merge(publicConfiguration['routes'], HealthCheckRoutes);
angular.merge(publicConfiguration['routes'], EEORoutes);
angular.merge(publicConfiguration['routes'], TeamliveRequestsEmployerRoutes);
angular.merge(publicConfiguration['routes'], TLClockTimeRoutes);
angular.merge(publicConfiguration['routes'], TeamLiveReportsRoutes);
angular.merge(publicConfiguration['routes'], CustomizedDashboardsRoutes);
angular.merge(publicConfiguration['routes'], OfferTemplatesRoutes);
angular.merge(publicConfiguration['routes'], PerformanceRoutes);
angular.merge(publicConfiguration['routes'], HrActionsTemplatesRoutes);
angular.merge(publicConfiguration['routes'], HarriEngageRoutes);
angular.merge(publicConfiguration['routes'], ChatBotRoutes);
angular.merge(publicConfiguration['routes'], ActivityBasedSchedulingRoutes);
angular.merge(publicConfiguration['routes'], DemandForecastingRoutes);
angular.merge(publicConfiguration['routes'], WendysLaborRoutes);
angular.merge(publicConfiguration['routes'], BarriRoutes);
angular.merge(publicConfiguration['routes'], AutoWageMatrixRoutes);
angular.merge(publicConfiguration['routes'], ScreeningQuestionsRoutes);
angular.merge(publicConfiguration['routes'], PeoplePlatformRoutes);
angular.merge(publicConfiguration['routes'], OnboardingManagersNotificationsRoutes);
angular.merge(publicConfiguration['routes'], McDLaborRoutes);
angular.merge(publicConfiguration['routes'], JibLaborRoutes);
angular.merge(publicConfiguration['routes'], GastronomyLaborRoutes);
angular.merge(publicConfiguration['routes'], CarrolLaborRoutes);
angular.merge(publicConfiguration['routes'], TipsDistributionBulkRoutesJS);
angular.merge(publicConfiguration['routes'], AvailabilityRequestsEmployerRoutes);
angular.merge(publicConfiguration['routes'], LiveScheduleAccessRoutes);
angular.merge(publicConfiguration['routes'], PermissionManagementRoutes);
angular.merge(publicConfiguration['routes'], TeamliveSettingsAuditRoutes);
angular.merge(publicConfiguration['routes'], EngagementDashboardsRoutes);
angular.merge(publicConfiguration['routes'], MiscellaneousPaymentRoutes);
angular.merge(publicConfiguration['routes'], ShiftTradeEmployerRoutes);
angular.merge(publicConfiguration['routes'], MinorSettingsManagementRoutes);
angular.merge(publicConfiguration['routes'], PerformanceSecondApprovalRoutes);
angular.merge(publicConfiguration['routes'], TipsDistributionRoutes);